var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#FF6700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8263 35.0514V39.0485C39.8278 39.4196 39.7516 39.7869 39.6027 40.1269C39.4537 40.4669 39.2353 40.7721 38.9613 41.0229C38.6873 41.2738 38.3639 41.4648 38.0117 41.5836C37.6595 41.7025 37.2863 41.7467 36.916 41.7133C32.8079 41.2678 28.8618 39.8668 25.3948 37.6229C22.1692 35.5773 19.4344 32.8479 17.3847 29.6287C15.1285 26.1528 13.7244 22.1954 13.2862 18.0771C13.2529 17.7086 13.2967 17.3373 13.4151 16.9867C13.5334 16.6361 13.7235 16.3139 13.9734 16.0407C14.2234 15.7675 14.5275 15.5492 14.8666 15.3997C15.2057 15.2502 15.5722 15.1728 15.9429 15.1725H19.9479C20.5958 15.1661 21.2239 15.3951 21.7152 15.8167C22.2064 16.2384 22.5273 16.8239 22.618 17.4642C22.787 18.7433 23.1005 19.9993 23.5525 21.2081C23.7321 21.685 23.771 22.2033 23.6645 22.7015C23.558 23.1998 23.3107 23.6572 22.9517 24.0194L21.2563 25.7115C23.1567 29.0472 25.9241 31.809 29.2663 33.7057L30.9618 32.0136C31.3248 31.6554 31.783 31.4085 32.2823 31.3023C32.7815 31.196 33.3008 31.2348 33.7787 31.4141C34.9899 31.8651 36.2484 32.178 37.5301 32.3467C38.1786 32.438 38.7708 32.764 39.1942 33.2627C39.6176 33.7614 39.8425 34.398 39.8263 35.0514Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBtn);
export default __webpack_public_path__ + "static/media/callBtn.bce4680cf6668e3650e694cc5b82b2ed.svg";
export { ForwardRef as ReactComponent };